
export interface SsoConfig{
  company: string;
  connection?: string;
};

interface CompanyConfig {
  domains: string[];
  connection?: string;
}


export const COMPANIES: Record<string, CompanyConfig> = {
  PAR:{
    domains: ['partech.com']

  },
  LSE:{
    connection: 'PixelPoint-LSE',
    domains: ['amf.com', 'bigkahunas.com', 'boomersparks.com', 'bowlero.com', 'bowlerocorp.com', 'bowlmor-amf.com', 'bowlmor.com', 'castlepark.com', 'emeraldpointe.com', 'lsent.com', 'luckystrikeent.com', 'pba.com', 'qmsolutions.com', 'ragingwaters.com', 'ragingwaves.com', 'shipwreckisland.com']
    
  }
}

export const SSO_MAP: Record<string, SsoConfig> =
  Object.fromEntries(
    Object.entries(COMPANIES).flatMap(([company, cfg]) =>
      cfg.domains.map(domain => [
        domain.toLowerCase(),
        { company, connection: cfg.connection }
      ])
    )
  );
